import { useTranslation } from "react-i18next";
import { Loader2, WifiOff } from "lucide-react";
import { Button } from "@tellescope/design-system";
import { useMeetingOperations } from "@tellescope/video-calling";
import { useCallDisconnectStatus } from "./useCallDisconnectStatus";
import { VideoCallTerminalNotice } from "./VideoCallTerminalNotice";

interface VideoCallDisconnectedNoticeProps {
  calendarEventId: string;
}

export const VideoCallDisconnectedNotice = ({ calendarEventId }: VideoCallDisconnectedNoticeProps) => {
  const { t } = useTranslation("videoCalling");
  const { leaveMeeting } = useMeetingOperations();
  const { status, rejoin } = useCallDisconnectStatus(calendarEventId);

  if (status === "ended") {
    return <VideoCallTerminalNotice reason="ended" />;
  }

  if (status === "checking") {
    return (
      <div className="flex-1 flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4 p-6 text-center">
      <WifiOff className="h-12 w-12 text-muted-foreground" />
      <p className="text-foreground" role="status">
        {t("You've been disconnected from the call")}
      </p>
      <div className="flex gap-2">
        <Button onClick={rejoin}>{t("Rejoin")}</Button>
        <Button variant="outline" onClick={leaveMeeting}>
          {t("Close")}
        </Button>
      </div>
    </div>
  );
};
